import { ICompanyMapPin, ICompanyMapPinResponse } from '@/bundles/Companies/types';
import { MapPinBase } from '@/bundles/Map/models/MapPinBase';
import { Nullable } from '@/utils/types';

export class CompanyMapPin extends MapPinBase implements ICompanyMapPin {
  readonly logoUrl: Nullable<string>;

  constructor (data: ICompanyMapPinResponse, number: number) {
    super(data, number);
    this.logoUrl = data.logo || null;
  }
}
